import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import * as d3 from 'd3';
import { iif } from 'rxjs';
@Component({
    selector: 'app-treemapsummary-chart',
    templateUrl: './treemap-summary.component.html'
})
export class TreemapSummaryComponent {
    @Input() GraphData: any;
    @Input() chartContainer: any;
    @Input() isExpand: boolean;
    constructor() { }
    //   ngOnInit(): void {

    //   }
    //   ngAfterViewInit() {
    //     this.RenderTreeMapSummaryCharts(this.GraphData);    
    //   }
    ngOnChanges() {
        //ngAfterViewInit() {
        if (this.GraphData && !this.isExpand) {
            this.RenderTreeMapSummaryCharts(this.GraphData);
        }
    }
    ngAfterViewInit() {
        if (this.GraphData && this.isExpand) {
            setTimeout(() => { this.RenderTreeMapSummaryCharts(this.GraphData); }, 500);
        }
    }
    RenderTreeMapSummaryCharts(inputData) {
        let treeDataTemp = [];
        let treeData: any;
        let that = this;
        let chartContainerName = '#' + this.chartContainer;
        treeDataTemp = inputData.map((d, i) => {
            return { 'id': d.CategoryName, 'value': d.TicketCount };
        });
        treeDataTemp = treeDataTemp.sort(function (a, b) {
            return b.value - a.value;
        });
        if (treeDataTemp.length > 10 && !this.isExpand) {
            treeDataTemp = treeDataTemp.slice(0, 10);
        }
        // inputData.yAxisCategories.forEach((d, i) => {
        //     var dummyData = inputData.chartData.filter(x => x.row == i);
        //     var childData = dummyData.map((d, i) => {
        //         return { 'id': inputData.xAxisCategories[d.col], 'value': d.data };
        //     });
        //     treeDataTemp.push({ 'id': inputData.yAxisCategories[i], 'children': childData });
        // });
        treeData = { 'id': 'Classified', 'children': treeDataTemp };
        d3.select(chartContainerName).html("");
        d3.select(chartContainerName).classed('treemapsummary', true);
        //document.getElementById(chartContainerName).innerHTML = '';
        //document.getElementById(chartContainerName).classList.add("treemap");
        var w = d3.select(chartContainerName).node().offsetWidth; //document.getElementById(chartContainerName).offsetWidth;        
        var h = 350;
        // if (this.isExpand) {
        //     w = 1098;
        //     h = 350;
        // }
        var margin = {
            top: 0,
            bottom: 10,
            left: 0,
            right: 0,
        };
        var containerName = chartContainerName.split('#')[1];
        var width = w - margin.left - margin.right;
        var height = h - margin.top - margin.bottom;
        var svg = d3.select(chartContainerName)
            .append('svg')
            .classed("resizableSVG", true)
            .attr('id', 'svg_' + containerName)
            .attr('xmlns', "http://www.w3.org/2000/svg")
            .attr('viewBox', "0 0 " + w + " " + h + "")
            .attr('preserveAspectRatio', 'xMidYMid meet')
            .style('overflow', 'visible')
            .append('g')
            .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
        //Tooltip
        const tooltip = d3.select('body')
            .append("div")
            .attr('class', 'tooltip')
            .style("opacity", 0);
        var fader = function (color) { return d3.interpolateRgb(color, "#fff")(0.2); };
        //color = d3.scaleOrdinal(d3.schemePaired)//.map(fader)),
        var color = d3.scaleOrdinal()
            .domain(["classified"])
            .range(["#008FFF"])
        var opacity = d3.scaleLinear()
            .domain([treeDataTemp[treeDataTemp.length - 1].value, treeDataTemp[0].value])
            .range([0.2, 1])
        let format = d3.format(",d");

        var treemap = d3.treemap()
            .tile(d3.treemapResquarify)
            .size([width, height])
            .round(true)
            .paddingTop(2)
            .paddingRight(1)
            .paddingInner(3)
            .paddingInner(1);

        var root = d3.hierarchy(treeData)
            .eachBefore(function (d) { return d.data.id }) // = (d.parent ? d.parent.data.id + "." : "") + d.data.id; })
            .sum(that.sumBySize)
            .sort(function (a, b) {
                return b.height - a.height || b.value - a.value;
            });
        treemap(root);

        var cell = svg.selectAll("g")
            .data(root.leaves())
            .enter().append("g")
            .attr("transform", function (d) { return "translate(" + d.x0 + "," + d.y0 + ")"; });
        cell.append("rect")
            .attr("id", function (d, i) { return containerName + "_tree" + i })
            .attr("width", function (d) { return d.x1 - d.x0; })
            .attr("height", function (d) { return d.y1 - d.y0; })
            // .attr("fill", function (d) { return color(d.parent.data.id); })
            // .style('opacity', '1')
            .attr('stroke', '#ffffff')
            //.style("stroke", "black")
            .style("fill", function (d) {
                return color(d.data.name)
            })
            .style("opacity", function (d) {
                return opacity(d.data.value);
            })
            .attr('stroke-width', '1px')
            .on('mouseenter', function (d, i) {
                d3.select(this).style("stroke", '#ffffff');
                //show tooltip
                tooltip.transition().duration(50).style('opacity', 0.9);
                tooltip.html(d.data.id + " : " + `${d3.format(",")(d.data.value)}`)
                    .style('left', (d3.event.pageX +10) + 'px')
                    .style('top', (d3.event.pageY) + 'px')
                    .style("display", "block");
                //.style('top', d3.event.target.getBoundingClientRect().top + 'px');
            })
            .on("mouseleave", function (actual, i) {
                //hide tooltip
                tooltip.transition().duration(800).style('opacity', 0);
            });
        svg
            .selectAll("text")
            .data(root.leaves())
            .enter()
            .append("text")
            .attr("x", function (d) { return d.x0 + 5 })
            .attr("y", function (d) {
                let heightRect = d.y1 - d.y0;
                if (heightRect >= 30)
                    return d.y0 + 20;
                else if (heightRect > 20 && heightRect < 30)
                    return d.y0 + 5;
                else
                    return d.y0 + (heightRect / 2) + 2;
            })
            .attr("font-size", "11px")
            .style('font-family', 'Graphik Regular')
            .style('font-weight', 'bold')
            .style('font-style', 'normal')
            .attr('data-width', (d) => d.x1 - d.x0)
            //.attr('width', '65px')
            //.style('overflow', '65px')
            .attr("fill", "black")
            .text(d => {
                let heightRect = d.y1 - d.y0;
                let widthtRect = d.x1 - d.x0;
                let val = d.data.id;//that.textValue(d);
                if (widthtRect < 40) {
                    if (heightRect > 80) {
                        return val;
                    }
                    else {
                        return that.textValue(d);
                    }
                } else {
                    if (heightRect > 80) {
                        return val;
                    }
                    else {
                        return that.textValue(d);
                    }
                }
            })
            .call(wrapText);
        function wrapText(selection) {
            selection.each(function () {
                const node = d3.select(this);
                const rectWidth = +node.attr('data-width');
                let word;
                //const words = node.text().split(' ').reverse();
                const existingwords = node.text().split(' ').reverse();
                const words = [];
                for (var i = 0; i < existingwords.length; i++) {
                    if (existingwords[i].length * 9 > rectWidth) {
                        let el = existingwords[i].substring(0, rectWidth / 21) + ".."
                        words.push(el);
                    }
                    else {
                        words.push(existingwords[i]);
                    }
                }
                let line = [];
                let lineNumber = 0;
                const x = node.attr('x');
                const y = node.attr('y');
                let tspan = node.text('').append('tspan').attr('x', x).attr('y', y);
                while (words.length > 1) {
                    word = words.pop();
                    line.push(word);
                    tspan.text(line.join(' '));
                    const tspanLength = tspan.node().getComputedTextLength();
                    if (tspanLength > rectWidth && line.length !== 1) {
                        line.pop();
                        tspan.text(line.join(' '));
                        line = [word];
                        tspan = addTspan(word);
                    }
                }
                addTspan(words.pop());

                function addTspan(text) {
                    lineNumber += 1;
                    return node
                        .append('tspan')
                        .attr('x', x)
                        .attr('y', y)
                        .attr('dy', `${lineNumber * 12}px`)
                        .text(text);
                }
            });
        }

        svg
            .selectAll("vals")
            .data(root.leaves())
            .enter()
            .append("text")
            .attr("x", function (d) { return (d.x0 + (d.x1 - d.x0)) - (d.data.value.toString().length * 10) })
            .attr("y", function (d) { return (d.y0 + (d.y1 - d.y0)) - 5 })
            .text(function (d) {
                let heightRect = d.y1 - d.y0;
                let widthtRect = d.x1 - d.x0;
                let val = d.data.value;
                if (heightRect < 40 || widthtRect < 40)
                    return '';
                return `${d3.format(",")(val)}`;
            })
            .attr("font-size", "10px")
            .style('font-family', 'Graphik Regular')
            .style('font-weight', 'bold')
            .style('font-style', 'normal')
            .attr("fill", "black")

        // svg
        //     .selectAll("titles")
        //     .data(root.descendants().filter(function (d) { return d.depth == 1 }))
        //     .enter()
        //     .append("text")
        //     .attr("x", function (d) { return d.x0 })
        //     .attr("y", function (d) { return d.y0 + 21 })
        //     .attr("font-size", "13px")
        //     .attr("fill", function (d) { return color(d.data.name) })

        //cell.append("title")
        //    .text(function (d) { return d.data.id + "\n" + format(d.value == 5.99999 ? 0 : d.value); });
    }
    sumBySize(d) {
        return d.value == 0 ? 5.99999 : d.value;
    }
    textValue(d) {
        var limit = Math.round(d.x1 - d.x0);
        var label = d.data.id;
        if (Math.round(d.y1 - d.y0) < 10)
            return '...';
        //if (limit >= 40) {
        //limit = (limit - 40) / 10 + 2;
        limit = Math.floor(limit / 7.2);
        //}
        // switch (true) {
        //     case limit < 10: return;
        //         break;
        //     case limit < 20: return;
        //         break;
        //     case limit < 30: return;
        //         break;
        //     case limit < 40: limit = 2;
        //         break;
        //     case limit < 50: limit = 3;
        //         break;
        //     case limit < 60: limit = 4;
        //         break;
        //     case limit < 70: limit = 5;
        //         break;
        //     case limit < 80: limit = 6;
        //         break;
        //     case limit < 90: limit = 7;
        //         break;
        //     case limit < 100: limit = 8;
        //         break;
        //     case limit < 110: limit = 9;
        //         break;
        //     default: limit = 10;
        //         break;
        // }
        //if (limit == 0)
        //    return "";
        if (d.data.id.length > limit) {
            if (limit > 3)
                label = d.data.id.substring(0, limit - 3) + '...';
            else
                label = '...';
        }
        return label;
    }
}
